import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { PTLSharedModule } from './shared/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { NgxLoadingModule } from 'ngx-loading';
import { AppComponent } from './app.component';
import { APP_ROUTES } from './app.routes';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthenticationService } from './shared/security/AuthenticationService';
import { StorageService } from './shared/security/StorageService';
import { LoginModule } from './login/login.module';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { TransactionsModule } from './transactions/transactions.module';
import { BrokerModule } from './broker/broker.module';
import { HomeModule } from './home/home.module';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { UserMessagesComponent } from './shared/utils/user-messages/user-messages.component';
import { HttpClientModule } from '@angular/common/http';
import { RenewalModule } from './renewal/renewal.module';

const rootRouting: ModuleWithProviders = RouterModule.forRoot(APP_ROUTES, { /*enableTracing: true,*/ useHash: true });

@NgModule({
  declarations: [
    AppComponent,
    UserMessagesComponent
  ],
  imports: [
    BrowserModule,
    PTLSharedModule,
    NgxLoadingModule,
    rootRouting,  
    HttpClientModule, 
    HttpModule, 
    FormsModule, 
    ReactiveFormsModule,
    LoginModule, 
    BrowserAnimationsModule, 
    TransactionsModule,
    BrokerModule, 
    HomeModule,
    RenewalModule,
    NgIdleKeepaliveModule.forRoot()
  ],
  providers: [
    NgxLoadingModule, 
    AuthenticationService, 
    StorageService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts